export default "__VITE_ASSET__Dgnuw6k0__"